import {
  formatApproximateDistanceLabel,
  getUserOriginCoords,
  type UserOriginCoords,
} from '@/lib/location/locationOriginCore';
import { useAuth } from '@/lib/auth/auth';
import { locationStore } from '@/lib/location/location';

export { formatApproximateDistanceLabel, getUserOriginCoords, type UserOriginCoords };

export function useUserOriginCoords(): UserOriginCoords {
  const session = useAuth((state) => state.session);
  const coords = locationStore((state) => state.coords);
  const isReady = locationStore((state) => state.isReady);
  const permissionDenied = locationStore((state) => state.permissionDenied);

  return getUserOriginCoords(session, { coords, isReady, permissionDenied });
}
